exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Events__events--127iO{background-image:url(" + require("../../../assets/url/events.svg") + ");background-repeat:no-repeat;background-position:right bottom -35px;background-size:239px 157px}@media (min-width:1025px){.Events__events--127iO{background-position:left bottom -35px;background-size:280px 183px}}", ""]);

// exports
exports.locals = {
	"events": "Events__events--127iO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/events/components/Events/Events.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/events/components/Events/Events.css
// module chunks = 1